import React, { Component } from 'react'

import { Button, Input, Space, Table } from 'antd';
import { connect } from 'react-redux';
import {fetchDriverStatistics} from '../../action/drivers'
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from "react-highlight-words";
import Header from '../../components/header';
class RiderStatc extends Component {
  state = { 
    
    searchText: '',
    searchedColumn: '',
    data: [],
   } 
    componentDidMount = () => {
        this.getData()
    };
    getData = async () => {
        const res = await this.props.fetchDriverStatistics()
        this.setState({data: res})
    }
   
  
    getColumnSearchProps =  dataIndex => ({
        filterDropdown:  ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
            <Input
            ref={node => {
                this.searchInput = node;
            }}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={e => {setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
                this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex,
                });}}
            onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ marginBottom: 8, display: 'block' }}
            />
            {/* <Space>
            <Button
                type="primary"
                onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
            >
                Search
            </Button>
            <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                Reset
            </Button>
            <Button
                type="link"
                size="small"
                onClick={() => {
                confirm({ closeDropdown: false });
                this.setState({
                    searchText: selectedKeys[0],
                    searchedColumn: dataIndex,
                });
                }}
            >
                Filter
            </Button>
            </Space> */}
        </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
        record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
        onFilterDropdownVisibleChange: visible => {
        if (visible) {
            setTimeout(() => this.searchInput.select(), 100);
        }
        },
        render: text =>
        this.state.searchedColumn === dataIndex ? (
            <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[this.state.searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
            />
        ) : (
            text
        ),
    });
    
    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
        searchText: selectedKeys[0],
        searchedColumn: dataIndex,
        });
    };

    createData = (user_id,name,mobile_number,delivered_order,hold_order,processing_order,return_order,collected_amount) => {
        return {user_id,name,mobile_number,delivered_order,hold_order,processing_order,return_order, collected_amount};
    };

    makeLocalTime = (date) => {
        let mainDate = date.split('T')[0];
        let hours = date.split('T')[1].split(':')[0];
        let minutes = date.split('T')[1].split(':')[1];
        var am = true;
        if (hours > 12) {
            am = false;
            hours -= 12
        } else if (hours == 12) {
            am = false;
        } else if (hours == 0) {
            hours = 12
        }
        return mainDate + " , " + hours+":"+minutes + " " + (am ? "a.m" : "p.m")
    }

    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    };


  render() { 
    
    const columns = [
      {
        title: 'ID',
        dataIndex: 'user_id',
        key: 'user_id',
        width: '15%',
        ...this.getColumnSearchProps('user_id'),
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        width: '20%',
        ...this.getColumnSearchProps('name'),
      },
      {
        title: 'Mobile Number',
        dataIndex: 'mobile_number',
        key: 'mobile_number',
        width: '20%',
        ...this.getColumnSearchProps('mobile_number'),
      },
      {
        title: 'Delivered Parcel',
        dataIndex: 'delivered_order',
        key: 'delivered_order',
        width: '10%',
      },
      {
        title: 'Hold Parcel',
        dataIndex: 'hold_order',
        key: 'hold_order',
        width: '12%',
      },
      {
        title: 'Parcel in Process',
        dataIndex: 'processing_order',
        key: 'processing_order',
        width: '12%',
      },
      {
        title: 'Return Parcel',
        dataIndex: 'return_order',
        key: 'return_order',
        width: '12%',
      },
      {
        title: 'Total Collection',
        dataIndex: 'collected_amount',
        key: 'collected_amount',
        width: '12%',
      }
    ];
    const {data} = this.state
    const rows = [...
      data
        ? data?.map((item,id) => this.createData(
            item.user_id
            , 
            item?.name,
            item?.mobile_number,
            item?.delivered_order,
            item?.hold_order,
            item?.processing_order,
            item?.return_order,
            item?.collected_amount
          ))
        : "",
    ];
    
    return (
      <>
        
        <Header title="Statistics of riders" subtitle="Riders" />
            {rows?.length > 0
            ? 
                <Table columns={columns} dataSource={rows} scroll={{ x: 1000 }} sticky  />
            : 
            null}
      </>
    );
  }
}

export default connect(null,{fetchDriverStatistics})(RiderStatc);